import { Component, Input } from "@angular/core";

@Component({
  selector: "ds-textarea",
  templateUrl: "./ds-textarea.component.html",
  styleUrls: ["./ds-textarea.component.scss"],
})
export class DsTextareaComponent {
  @Input() error: boolean = false;

  constructor() {}
}
